module.exports = __webpack_public_path__ + "static/media/contactBg.31cb05f3.jpg";